import history from 'bz-utilities/modules/networking/history/rr4';
import { Button } from 'click-controls';
import { action } from 'mobx';
import { observer } from 'mobx-react';
import React from 'react';
import z from 'z';
interface IProps {}

@observer
export class ResetSent extends React.Component<IProps> {
  @action.bound
  onNavigateTo(path) {
    history.push(path);
  }

  render() {
    return (
      <div>
        <h3 className="mb-4 text-3xl font-bold">Nearly There</h3>
        <p className="mb-12 text-left text-base">
          Just check your email for your password reset link. If the email address entered has been
          used to register a {z.word('TM3')} account you should receive the email shortly.
        </p>
        <Button className="btn" onClick={this.onNavigateTo.bind(this, '/login')}>
          Return to the Login screen
        </Button>
      </div>
    );
  }
}

export default ResetSent;
